import { render, staticRenderFns } from "./BookSummaryMini.vue?vue&type=template&id=f5c2a57e&scoped=true&"
import script from "./BookSummaryMini.vue?vue&type=script&lang=js&"
export * from "./BookSummaryMini.vue?vue&type=script&lang=js&"
import style0 from "./BookSummaryMini.vue?vue&type=style&index=0&id=f5c2a57e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c2a57e",
  null
  
)

export default component.exports